(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoVirtualRegenerarService', ReporteEvaluativoVirtualRegenerarService);

    ReporteEvaluativoVirtualRegenerarService.$inject = ['$resource'];

    function ReporteEvaluativoVirtualRegenerarService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/regenerarreporteVirtual:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
        	'regenerar': {
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreportevirtualregenerar:id',
            	method:'PUT' 
            }
        });
    }
})();